import { temporarilyNotSupport } from '../../utils'

// 内存
export const onMemoryWarning = temporarilyNotSupport('onMemoryWarning')
export const offMemoryWarning = temporarilyNotSupport('offMemoryWarning')
